import { IEarlyAssessmentWFState } from '../types/workflow-phases';

export const earlyAssessmentStatusByReviewRound = {
  firstReviewRound: [
    'invited',
    'assessment',
    'interrupted',
    'reviewed',
    'declined',
    'expired',
    'rescinded',
    'firstAssessment',
    'submittedFirstAssessment'
  ],
  revisionReviewRound: [
    'awaitingRevision',
    'awaitingRevisionReviewRequest',
    'revisionAssessment',
    'submittedRevisionAssessment',
    'revisionInvited'
  ]
};

/**
 * Active = Requires attention.
 * Inactive = Does not require attention.
 */
const activeVsInactiveAssessmentStatus: Record<
  IEarlyAssessmentWFState,
  'active' | 'inactive'
> = {
  submittedFirstAssessment: 'inactive',
  awaitingRevision: 'inactive',
  awaitingRevisionReviewRequest: 'inactive',
  submittedRevisionAssessment: 'inactive',
  removed: 'inactive',
  reviewed: 'inactive',
  declined: 'inactive',
  expired: 'inactive',
  invited: 'active',
  firstAssessment: 'active',
  rescinded: 'active',
  revisionAssessment: 'active',
  revisionInvited: 'active',
  interrupted: 'inactive',
  assessment: 'active',
  initial: 'active'
};

export const inactiveAssessmentStatuses: IEarlyAssessmentWFState[] =
  Object.entries(activeVsInactiveAssessmentStatus)
    .filter(([_, value]) => value === 'inactive')
    .map(([key, _]) => key);
